// React import
import React from 'react';
import { connect } from "react-redux";
import {bindActionCreators} from "redux";
import {setPage} from "../../actions";
// Components import
import WalletBalanceItem from "../WalletBalanceItem";
// Styles imports
import './WalletBalance.css';
import '../../util.css';
// Svg imports
import { ReactComponent as DirectUpSvg } from '../../svg-icons/arrow-up.svg';
// Consts imports
import {LEVEL_FEATURES, PAGE_UPGRADE, PORTFOLIO} from "../../consts/consts";

function AvailableTitle(props) {

    const { level } = props;

    return (
        <span className={"check-wallet__balances-item__block_text_available"}>
            Upgrade to <br/>AI level {level}
        </span>
    );

}

class WalletBalance extends React.Component {

    constructor(props) {
        super(props);
    }

    handleUpgradeClick = () => {
        const { setPage } = this.props;
        setPage(PAGE_UPGRADE);
    };

    render () {

        const { walletBalances } = this.props.checkWallet;
        const { ai_level } = this.props.userData;
        let aiLevelInt = parseInt(ai_level);

        if ( aiLevelInt < LEVEL_FEATURES[PORTFOLIO]) {
            return(
                <div className={"check-wallet__balances-item-available noselect"} onClick={this.handleUpgradeClick}>
                    <DirectUpSvg className={"check-wallet-balances-block-item-icon-direct-up"}/>
                    <AvailableTitle level={LEVEL_FEATURES[PORTFOLIO]}/>
                </div>
            );
        }

        return(
            <div className={"check-wallet__balances-block noselect"}>
                {walletBalances.map((walletBalance, index) =>
                    <WalletBalanceItem
                        key={index}
                        address={walletBalance.address}
                        index={index}
                        symbol={walletBalance.symbol}
                        name={walletBalance.name}
                        indicator={walletBalance.indicator}
                        balance={walletBalance.balance}
                        price={walletBalance.price}
                        value={walletBalance.value}
                        change={walletBalance.change}
                    />
                )}
            </div>
        );
    }

}

const mapStateToProps = ({ checkWallet, userData }) => {
    return { checkWallet, userData };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setPage,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(WalletBalance);